import React, { useEffect, useState } from "react";
import { Row, Col } from "../../ui/Grid";
import Skeleton from "../../ui/Skeleton";
import { CopyToClipboard } from "react-copy-to-clipboard";
import shortLinkGIF from "../../FormLocalSearch/assets/audit/shortLink.gif";

import ratingPicture from "../../FormLocalSearch/assets/audit/Note.png";
import reviewsPicture from "../../FormLocalSearch/assets/audit/nombre-avis.png";
import ProgressCircle from "../ProgressCircle";
import useLang from "../../../i18n/useLang";
import content from "./content";

const Reviews = ({ auditInfo }) => {
  const all = content[useLang()];
  const t = all.reviews;
  const [score, setScore] = useState();
  const [shortLink, setShortLink] = useState();
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getScore = async () => {
      let score = 0;
      if (auditInfo.Nbreviews > 10) {
        score = score + 50;
      }
      if (auditInfo.Rating >= 4) {
        score = score + 50;
      }

      setScore(score);
      setShortLink(
        `http://search.google.com/local/writereview?placeid=${auditInfo.PlaceID}&hl=${all.googleHl}`,
      );
      setLoading(false);
    };
    getScore();
  }, [auditInfo.Nbreviews, auditInfo.Rating, auditInfo.BusinessID, auditInfo.PlaceID, all.googleHl]);
  if (loading) {
    return (
      <>
        <div className="featureblock-container">
          <div className="card-header">
            <span>{all.essentials.title}</span>
          </div>
          <div className="card-graph-body">
            <div className="sumup-category">
              <Skeleton />
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="featureblock-container">
          <div className="card-header">
            <span>{t.title}</span>
          </div>
          <div className="card-graph-body">
            <div className="sumup-category">
              <Row>
                <Col xl={10} lg={10} sm={24} className="progress-category">
                  <ProgressCircle type="circle" score={score} />
                </Col>
                <Col xl={14} lg={14} sm={24}>
                  <div style={{ marginTop: "20px" }}>
                    {t.intro}
                  </div>
                </Col>
              </Row>
            </div>
            <div className="criteria-audit">
              <Row gutter={30}>
                <Col xl={14} lg={14} sm={24}>
                  <div className="criteria-status">
                    <span>
                      {auditInfo.Nbreviews > 10 ? (
                        <>
                          <span
                            role="img"
                            className="issue-icon"
                            aria-label="emoji"
                          >
                            ✅
                          </span>
                          {t.enough}{" "}
                        </>
                      ) : (
                        <>
                          <span
                            role="img"
                            className="issue-icon"
                            aria-label="emoji"
                          >
                            ❌
                          </span>
                          {t.notEnough}
                        </>
                      )}
                    </span>
                  </div>
                  <div className="criteria-description">
                    <span>{t.countDesc}</span>
                  </div>
                </Col>
                <Col xl={10} lg={10} sm={24}>
                  {" "}
                  <img src={reviewsPicture} width="80%" alt={t.countAlt} />
                </Col>
              </Row>
            </div>
            <div className="criteria-audit">
              <Row gutter={30}>
                <Col xl={14} lg={14} sm={24}>
                  <div className="criteria-status">
                    <span>
                      {auditInfo.Rating >= 4 ? (
                        <>
                          {" "}
                          <span
                            role="img"
                            className="issue-icon"
                            aria-label="emoji"
                          >
                            ✅
                          </span>
                          {t.goodRating}{" "}
                        </>
                      ) : (
                        <>
                          {" "}
                          <span
                            role="img"
                            className="issue-icon"
                            aria-label="emoji"
                          >
                            ❌
                          </span>
                          {t.badRating}
                        </>
                      )}
                    </span>
                  </div>
                  <div className="criteria-description">
                    <span style={{ fontSize: 16 }}>
                      {t.yourRating(auditInfo.Rating)}
                    </span>
                    <br />
                    <br />
                    <span>{t.ratingDesc}</span>
                  </div>
                </Col>
                <Col xl={10} lg={10} sm={24}>
                  {" "}
                  <img src={ratingPicture} width="80%" alt={t.ratingAlt} />
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <div className="featureblock-container-info">
          <div className="card-header">
            <span>{all.didYouKnow}</span>
          </div>
          <div className="card-graph-body">
            <div className="sumup-category">
              <Row>
                <Col xl={13} lg={13} sm={24}>
                  <div className="criteria-status">
                    <span>
                      <span
                        role="img"
                        className="issue-icon"
                        aria-label="emoji"
                      >
                        💡
                      </span>
                      {t.tipTitle}{" "}
                    </span>
                  </div>
                  <div className="criteria-description">
                    <span style={{ fontSize: 16 }}>
                      {t.tipSubtitle}
                    </span>
                    <br />
                    <span>
                      <br />
                      {t.tip}
                      <div className="short-link">
                        <input className="input" value={shortLink} disabled />
                        <CopyToClipboard
                          text={shortLink}
                          onCopy={() => setCopied(true)}
                        >
                          <button
                            className="btn btn--primary"
                            style={{
                              backgroundColor: "#2e4556",
                              borderColor: "#2e4556",
                              width: "fit-content",
                              height: "40px",
                              borderRadius: "0px 5px 5px 0px",
                            }}
                          >
                            {!copied ? t.copy : t.copied}
                          </button>
                        </CopyToClipboard>
                      </div>
                    </span>
                  </div>
                </Col>
                <Col xl={11} lg={11} sm={24}>
                  <img src={shortLinkGIF} width="100%" alt={t.gifAlt} />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default Reviews;
